import { useAuth } from '@/auth/auth-provider'
import loginBackground from '@/assets/images/login_background.jpg'
import {
    Box,
    Button,
    Center,
    Loader,
    Paper,
    Stack,
    Text,
    Title
} from '@mantine/core'
import { IconArrowLeft } from '@tabler/icons-react'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export const ForgotPasswordPage = () => {
  const { signIn } = useAuth()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  
  const handleResetPassword = async (e?: React.FormEvent) => {
    e?.preventDefault()
    setIsLoading(true)
    try {
      // The identity provider owns the password reset flow
      await signIn()
    } catch (error) {
      console.error('Password reset error:', error)
      setIsLoading(false)
    }
  }

  const handleBackToLogin = () => {
    navigate('/login')
  }

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    )
  }

  return (
    <Box
      className="auth-page-container"
      style={{
        backgroundImage: `url(${loginBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Overlay gradient */}
      <Box
        pos="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        style={{
          background: 'linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(0,100,200,0.3) 100%)',
        }}
      />

      <Box className="auth-container">
        <Paper className="auth-paper" withBorder>
          <Stack className="auth-stack">
            {/* Header */}
            <Box className="auth-header">
              <Title order={1} className="auth-title">
                RESET YOUR PASSWORD
              </Title>
              <Text className="auth-subtitle">
                Enter your email address to receive password reset instructions and regain access to your dealership portal.
              </Text>
            </Box>

                    {/* Reset Form */}
                    <form onSubmit={handleResetPassword}>
                      <Stack className="auth-stack">
                        <Button
                          type="submit"
                          fullWidth
                          size="xl"
                          loading={isLoading}
                          color="orange"
                          className="auth-button-primary"
                        >
                          Reset Password
                        </Button>

                        <Button
                          type="button"
                          fullWidth
                          size="lg"
                          onClick={handleBackToLogin}
                          variant="outline"
                          leftSection={<IconArrowLeft size={16} />}
                          className="auth-button-secondary"
                        >
                          Back to Login
                        </Button>
                      </Stack>
                    </form>

            {/* Footer */}
            <Box ta="center">
              <Text size="xs" c="dimmed">
                Remember your password?{' '}
                <Text 
                  component="a" 
                  href="/login" 
                  c="blue" 
                  style={{ textDecoration: 'none' }}
                >
                  Sign in here
                </Text>
              </Text>
            </Box>
          </Stack>
        </Paper>
      </Box>
    </Box>
  )
}
